import { InjectionToken } from '@angular/core';
import { LocalCache } from '@nk/caching-lib';
import { AppContentEntity, AppMessageOfTheDay, AppSurveyEntity } from '@nk/data-entities-lib';
import { Observable } from 'rxjs';

export interface AppContentApiService {
  appContentByIdentifierCache: LocalCache<AppContentApiService, (identifier: string) => Observable<AppContentEntity>>;
  fetchAppContentByIdentifier(identifier: string): Observable<AppContentEntity>;

  appContentMessageOfTheDayCache: LocalCache<
    AppContentApiService,
    (identifier: string) => Observable<AppMessageOfTheDay[]>
  >;
  fetchAppContentMessageOfTheDay(identifier: string): Observable<AppMessageOfTheDay[]>;

  appSurveyCache: LocalCache<
    AppContentApiService,
    (appMembershipUuid: string, languageCode: string) => Observable<AppSurveyEntity[]>
  >;
  fetchAppSurvey(appMembershipUuid: string, languageCode: string): Observable<AppSurveyEntity[]>;
}

export const APP_CONTENT_API_SERVICE_TOKEN = new InjectionToken<AppContentApiService>('AppContentApiService');
